// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const { formatText } = require('core/i18n').i18n;

class RAFirstAnswerModal extends React.Component {
    render() {
        const { closeModal } = this.props;

        return (
            <OKModal
                description={formatText(
                    'raSuitabilityTest-firstAnswerModal_description',
                )}
                descriptionAlignment="center"
                footerType={'action'}
                headerType="custom"
                isOpen={true}
                onCloseCallback={closeModal}
                onPrimaryButtonClick={closeModal}
                primaryButtonText={formatText(
                    'raSuitabilityTest-firstAnswerModal_button',
                )}
                shouldCloseOnOverlayClick={false}
                title={formatText('raSuitabilityTest-firstAnswerModal_title')}
                titleAlignment="center"
            />
        );
    }
}

RAFirstAnswerModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
};

module.exports = RAFirstAnswerModal;
